import React, {useContext, useEffect, useState} from "react";
import ArchivioMarcheView from "./ArchivioMarcheView";
import {MobileContext} from "../../context/MobileContext";
import TreeContainer from "../../components/tree/TreeContainer";
import {LoaderContext} from "../../context/LoaderContext";
import {useHistory, useParams} from "react-router-dom";
import {FiltersContext} from "../../context/FiltersContext";
import {BreadcrumbsContext} from "../../context/BreadcrumbsContext";
import {getMarcheArchivioApi} from "../../services/ArchivioServices";
import {ARCHIVIO_TIPO_VEICOLO_AUTO} from "../../utility/common";

export default function ArchivioMarcheController({}) {
    const {idTipoVeicolo} = useParams();

    const [marche, setMarche] = useState([]);
    const [filtroAlbero, setFiltroAlbero] = useState('');

    const {isMobile} = useContext(MobileContext);
    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {updateFiltroArchivio} = useContext(FiltersContext);
    const {initElementiBreadcrumbs, addElementoBreadcrumbs} = useContext(BreadcrumbsContext);

    const history = useHistory();

    async function getMarche() {
        startChiamata();
        const response = await getMarcheArchivioApi({
            tipo_veicolo: idTipoVeicolo
        });
        endChiamata();

        setMarche(response.data.data);
    }

    function getTitolo() {
        return `Archivio ${parseInt(idTipoVeicolo) === ARCHIVIO_TIPO_VEICOLO_AUTO ? 'Auto' : 'Moto'}`;
    }

    useEffect(() => {
        getMarche();

        /* Pulisco l'array di elementi del BreadcrumbsContext */
        initElementiBreadcrumbs('archivio', getTitolo(), `/archivio/${idTipoVeicolo}`);
    }, [idTipoVeicolo]);

    function getAlberoStruttura() {
        const marcheFiltrate = filtroAlbero
            ? marche.filter(m => m.marca?.toLowerCase().includes(filtroAlbero.toLowerCase()))
            : marche;

        return (
            <div>
                <div className={'ns-filtro-albero'}>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Cerca marca..."
                        value={filtroAlbero}
                        onChange={(e) => setFiltroAlbero(e.target.value)}
                    />
                </div>
                <div className={'ns-overflow-auto ns-overflow-tree'}>
                    <TreeContainer
                        data={marcheFiltrate}
                        idSelected={''}
                        onClickItem={(elemento) => {
                            addElementoBreadcrumbs('marca', elemento.marca, `/archivio-marca/${elemento.id_archivio_marca}`);
                            updateFiltroArchivio('id_archivio_marca', elemento.id_archivio_marca);
                            history.push(`/archivio-marca/${elemento.id_archivio_marca}`);
                        }}
                        getLabel={(elemento) => elemento.marca}
                        getFigli={(elemento) => []}
                        icona={(elemento) => {
                        }}
                    />
                </div>
            </div>
        );
    }

    return (
        <ArchivioMarcheView
            isMobile={isMobile}
            getAlberoStruttura={getAlberoStruttura}
            title={getTitolo()}
            marche={marche}
            handlerRefreshMarche={getMarche}
            tipoVeicolo={idTipoVeicolo}
        />
    );
}